import { render } from "./WCAG.vue?vue&type=template&id=63beb706&scoped=true"
import script from "./WCAG.vue?vue&type=script&lang=js"
export * from "./WCAG.vue?vue&type=script&lang=js"

import "./WCAG.vue?vue&type=style&index=0&id=63beb706&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63beb706"]])

export default __exports__